import request from "../../untils/request.js"

//主诉模板分页
export const getComplaintemplate = (params) => {
    return request.get("/outpatient/complaintemplate/page", {params} )
}

//既往史模板分页
export const getBeforeHistoryTemplate = (params) => {
    return request.get('/outpatient/historysicknesstemplate/page',{params})
}

//现病史模板分页
export const getNowHistoryTemplate = (params) => {
    return request.get('/outpatient/nowsicknesstemplate/page',{params})
}

//病历模板分页
export const getMedicalRecordTemplate= (params) => {
    return request.get('/outpatient/medicaltemplate/page',{params})
}

//病历模板保存
export const addMedicalRecordTemplate= (data) => {
    return request.post('/outpatient/medicaltemplate',data)
}

export default{

}